export default "__VITE_ASSET__BGw$32jz__"